import api from './api'

class AuthService {
  // Register new user
  async register(userData) {
    const response = await api.post('/auth/register', userData)
    return response.data
  }

  // Login user
  async login(credentials) {
    const response = await api.post('/auth/login', credentials)
    // AccessToken stored in Redux state (memory only)
    // RefreshToken stored in HttpOnly cookie (handled by backend)
    return response.data
  }

  // Logout user
  async logout() {
    try {
      // Backend clears HttpOnly cookie
      await api.post('/auth/logout')
    } catch (error) {
      console.error('Logout error:', error)
    }
    // Redux state cleared via clearCredentials action
  }

  // Logout from all devices
  async logoutAll() {
    try {
      // Backend clears all sessions and cookies
      await api.post('/auth/logout-all')
    } catch (error) {
      console.error('Logout all error:', error)
    }
    // Redux state cleared via clearCredentials action
  }

  // Refresh access token
  async refreshAccessToken() {
    // The refreshToken cookie is automatically sent by the browser
    const response = await api.post('/auth/refresh')
    // New accessToken will be stored in Redux state via refreshToken thunk
    return response.data
  }

  // Get active sessions
  async getSessions() {
    const response = await api.get('/auth/sessions')
    return response.data
  }

  // Note: User data and accessToken are now in Redux state only (memory)
  // Use Redux selectors: state.auth.user, state.auth.accessToken, state.auth.isAuthenticated
}

const authService = new AuthService()
export default authService
